/**
 * Copyright © 2025 Delicious AI, LLC
 *
 * @author Mitch Wilson <mitchell.wilson@deliciousai.com>
 */

import { gql } from '@apollo/client'

import { GROUP_FRAGMENT } from '../fragments'

export const GET_GROUPS = gql`
  query GetGroups {
    groups {
      results {
        ...Group
      }
    }
  }
  ${GROUP_FRAGMENT}
`
